import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import API_URL from '../../config'

// Define keyframes for animation
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

// Main container styled component
const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
  padding: 3rem;
`;

// Login box styled component
const LoginForm = styled.div`
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 7px;
  padding: 30px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
  transform-style: preserve-3d;
  width: 270px;

  &:hover {
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.3); 
  }
`;

const Heading = styled.h1`
  margin: 1rem 0;
`;

// Form styled component
const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

// Input field styled component
const Input = styled.input`
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px solid #ccc;
  outline: none;
  color: #111;
  background-color: transparent;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  /* background-color: rgba(0,0,0,0.6); */
`;

const Error= styled.h5`
  color: #e66;
  padding: 1rem 0;
`

// Submit button styled component
const Button = styled.button`
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #111;
  color: #fff;
  cursor: pointer;
  outline: none;
`;

const LoginPage = ({ authenticateUser }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [error, setError] = useState('');
  const navigate= useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
  
    try {
      // Make POST request to /login endpoint
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
  
      if (response.ok) {
        // If authentication is successful
        const data = await response.json();
        // Example: Set authentication token in local storage
        // console.log(response)
        localStorage.setItem('token', data.token);
        authenticateUser();
        // Redirect user to dashboard page
        navigate('/admin');
        // navigate('http://localhost:5173/admin');

      } else {
        // If authentication fails
        console.error('Login failed');
        alert(`Invalid password: ${response.text()}`);
      }
    } catch (error) {
      console.error('Error occurred:', error);
      setError(error.message);
    }
  };
  
  // Redirect to admin page if isLoggedIn is true
  // if (isLoggedIn) {
  //   return <Navigate to="/admin" replace={true} />;
  // }

  return (
    <LoginContainer>
      <LoginForm>
        <Heading>Login</Heading>
        {error && <Error>{error}</Error>}
        <Form onSubmit={handleLogin}>
          <Input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button type="submit">Login</Button>
        </Form>
      </LoginForm>
    </LoginContainer>
  );
};

export default LoginPage;
